import WRAP from 'WRAP-JS'
import { configTrainingAirspaceADIZDh, configTrainingAirspaceCivilDh, configTrainingAirspaceHighDh, configTrainingAirspaceLayer, configTrainingAirspaceLowDh } from './config/ConfigTrainingAirspace';
import { MAP_ID_TRAINING_AIRSPACE } from "../../../store/MapContentsState";
import Mutex from '../../../utils/Mutex';
import Color from 'color';
import { COMMUNICATE_ERROR_MESSAGE_TRAINING_AIRAPACE, COMMUNICATE_ERROR_MESSAGE_TRY_AGAIN_RELOAD } from '../../../constants/ErrorMessage';
import { TOOLTIP_GROUP_1 } from '../Map';

class TrainingAirspace {
  static NAME = MAP_ID_TRAINING_AIRSPACE;
  static TRAINING_AIRSPACE_JSDF_HIGH = `${this.NAME}_JSDF_HIGH`;
  static TRAINING_AIRSPACE_JSDF_LOW = `${this.NAME}_JSDF_LOW`;
  static TRAINING_AIRSPACE_CIVIL = `${this.NAME}_CIVIL`;
  static TRAINING_AIRSPACE_ADIZ = `${this.NAME}_ADIZ`;
  static CONTENTS_VISIBLE_STATE_DEFAULT = {
    [this.TRAINING_AIRSPACE_JSDF_HIGH]: true,
    [this.TRAINING_AIRSPACE_JSDF_LOW]: true,
    [this.TRAINING_AIRSPACE_CIVIL]: true,
    [this.TRAINING_AIRSPACE_ADIZ]: true,
  };

  // 自衛隊高高度
  dhJSDFHigh;
  layerJSDFHigh;

  // 自衛隊低高度
  dhJSDFLow;
  layerJSDFLow;

  // 民間
  dhCivil;
  layerCivil;

  // 防空識別圏
  dhADIZ;
  layerADIZ;

  contentsInitialized = Object.keys(this.constructor.CONTENTS_VISIBLE_STATE_DEFAULT).reduce((a, v) => {a[v] = false; return a;}, {});

  contentsVisibleState = {...this.constructor.CONTENTS_VISIBLE_STATE_DEFAULT};

  ready = false;

  contentsDispatcher;

  constructor() {
    this.layerJSDFHigh = new WRAP.Geo.Layer(`${this.constructor.TRAINING_AIRSPACE_JSDF_HIGH}`);
    this.layerJSDFHigh.setVisible(false);
    this.layerJSDFHigh.setRespondable(true, true);

    this.layerJSDFLow = new WRAP.Geo.Layer(`${this.constructor.TRAINING_AIRSPACE_JSDF_LOW}`);
    this.layerJSDFLow.setVisible(false);
    this.layerJSDFLow.setRespondable(true, true);

    this.layerCivil = new WRAP.Geo.Layer(`${this.constructor.TRAINING_AIRSPACE_CIVIL}`);
    this.layerCivil.setVisible(false);
    this.layerCivil.setRespondable(true, true);
    this.layerCivil.setStyle('civil');

    this.layerADIZ = new WRAP.Geo.Layer(`${this.constructor.TRAINING_AIRSPACE_ADIZ}`);
    this.layerADIZ.setVisible(false);
    this.layerADIZ.setRespondable(true, true);
    this.layerADIZ.setStyle('adiz');

    this.drawLayerMutex = new Mutex();
  }

  async initialize(dataType) {
    await this.initData(dataType);
    this.initLayer(dataType);
    this.ready = true;
  }

  async initData(dataType) {
    return new Promise(resolve => {
      let config;
      let dh;

      switch (dataType) {
        case this.constructor.TRAINING_AIRSPACE_JSDF_HIGH:
          config = configTrainingAirspaceHighDh;
          dh = this.dhJSDFHigh = new WRAP.Data(config);
          break;
        case this.constructor.TRAINING_AIRSPACE_JSDF_LOW:
          config = configTrainingAirspaceLowDh;
          dh = this.dhJSDFLow = new WRAP.Data(config);
          break;
        case this.constructor.TRAINING_AIRSPACE_CIVIL:
          config = configTrainingAirspaceCivilDh;
          dh = this.dhCivil = new WRAP.Data(config);
          break;
        case this.constructor.TRAINING_AIRSPACE_ADIZ:
          config = configTrainingAirspaceADIZDh;
          dh = this.dhADIZ = new WRAP.Data(config);
          break;
        default:
      }

      if (dh) {
        dh.load('data', null, false, ref => {
          resolve(ref);
        }, _ => {
          this.contentsDispatcher({type: 'SHOW_ERROR', payload: {
            message: COMMUNICATE_ERROR_MESSAGE_TRAINING_AIRAPACE,
            additionalMessage: COMMUNICATE_ERROR_MESSAGE_TRY_AGAIN_RELOAD
          }});
          resolve();
        });
      }

      this.contentsInitialized[dataType] = true;

    });
  }

  initLayer(dataType) {
    const target = this._getTarget(dataType);
    if (Array.isArray(target.layer)){
      for (let i = 0; i < target.layer.length; i++) {
        target.layer[i].configure(target.dh, target.layerConfig[i]);
        if (target.tooltip) {
          target.layer[i].setTooltip(target.tooltip, true);
        }
      }
    } else if (target.layer) {
      target.layer.configure(target.dh, target.layerConfig);
      if (target.tooltip) {
        target.layer.setTooltip(target.tooltip, true);
      }
    }
  }

  initInteraction() {
    WRAP.Geo.addEventHandler('mouseover', (layer, feature, sp) => {
      if (this._allLayers().includes(layer)) {
        [feature].forEach(f => {
          if (this._allLayers().includes(f.layer)) {
            const s = f.style();
            s._orgLineWidth = s.lineWidth;
            s._orgFillStyle = s.fillStyle;
            s.lineWidth = 4;
            s.fillStyle = Color(s.fillStyle).alpha(0.2).toString();
            // WebGLの再描画条件
            f.layer._modified = true;
            f.layer._immediate = true;
          }
        });
        WRAP.Geo.invalidate();
      }
    });

    WRAP.Geo.addEventHandler('mouseout', (layer, feature, sp) => {
      if (this._allLayers().includes(layer)) {
        [feature].forEach(f => {
          const s = f.style();
          if ('_orgLineWidth' in s) {
            s.lineWidth = s._orgLineWidth;
            delete s._orgLineWidth;
          }
          if ('_orgFillStyle' in s) {
            s.fillStyle = s._orgFillStyle;
            delete s._orgFillStyle;
          }
          // WebGLの再描画条件
          f.layer._modified = true;
          f.layer._immediate = true;
        });
        WRAP.Geo.invalidate();
      }
    });
  }

  async drawLayer(visible, type) {
    this.drawLayerMutex.runExclusion(async () => {
      let _type = type;
      if (!type) {
        _type = this._visibleArea();
      }

      for (const t of [].concat(_type)) {
        if (visible && !this.contentsInitialized[t]) {
          await this.initialize(t);
        }
        if (type) {
          this.setVisible(visible, t);
        }
      }
      if (!type) {
        this.setVisible(visible);
      }
    });
  }

  getLayer() {
    return this._allLayers();
  }

  getTooltipGroup() {
    return {
      id: TOOLTIP_GROUP_1,
      layers: [this.layerJSDFHigh, this.layerJSDFLow, this.layerCivil, this.layerADIZ]
    };
  }

  getLegend() {
    return {
      id: TrainingAirspace.NAME,
      label: 'Training airspace/ADIZ'
    };
  }

  setVisible(visible, type) {
    if (type) {
      this.contentsVisibleState[type] = visible;
    }

    if (type) {
      if (!this.contentsInitialized[type]) {
        return;
      }

      const target = this._getTarget(type);

      if (Array.isArray(target.layer)) {
        if (target.layer[0].visible() === visible) {
          return;
        }

        for (let i = 0; i < target.layer.length; i++) {
          if (visible && this.visible) {
            if (!this.coverage && target.layer[i]._conf.Attributes.layer_type === 'coverage') {
              continue;
            }
            target.layer[i].show();
          } else {
            target.layer[i].hide();
          }
        }

      } else if (target.layer) {
        if (target.layer.visible() === visible) {
          return;
        }

        if (visible && this.visible) {
          target.layer.show();
        } else {
          target.layer.hide();
        }
      }
    } else {
      this.visible = visible;
      if (visible) {
        this._visibleArea().forEach(v=> {
          const target = this._getTarget(v);
          if (target.layer.visible()) {
            return;
          }
          target.layer.show();
        });
      } else {
        this._allLayers().forEach(layer => {
          if (!layer.visible()) {
            return;
          }
          layer.hide();
        });
      }
    }
  }

  getContentsVisibleState() {
    return this.contentsVisibleState;
  }

  resetContentsVisibleState() {
    this.contentsVisibleState = {...this.constructor.CONTENTS_VISIBLE_STATE_DEFAULT};
  }

  changeRoutePointEditing(routePointEditing) {
    this._visibleArea().forEach(v=> {
      const target = this._getTarget(v);
      target.layer.disableInteraction(routePointEditing);
    });
  }

  _visibleArea() {
    return Object.keys(this.contentsVisibleState).sort().reduce((visibleAreaList, area) => {
      if (this.contentsVisibleState[area]) {
        visibleAreaList.push(area)
      }
      return visibleAreaList;
    }, []);
  }

  _getTarget(dataType) {
    let dh;
    let layer;
    let layerConfig;
    let tooltip;
    switch (dataType) {
      case this.constructor.TRAINING_AIRSPACE_JSDF_HIGH:
        dh = this.dhJSDFHigh;
        layer = this.layerJSDFHigh;
        layerConfig = configTrainingAirspaceLayer;
        tooltip = this._tooltip.bind(this);
        break;
      case this.constructor.TRAINING_AIRSPACE_JSDF_LOW:
        dh = this.dhJSDFLow;
        layer = this.layerJSDFLow;
        layerConfig = configTrainingAirspaceLayer;
        tooltip = this._tooltip.bind(this);
        break;
      case this.constructor.TRAINING_AIRSPACE_CIVIL:
        dh = this.dhCivil;
        layer = this.layerCivil;
        layerConfig = configTrainingAirspaceLayer;
        tooltip = this._tooltip.bind(this);
        break;
      case this.constructor.TRAINING_AIRSPACE_ADIZ:
        dh = this.dhADIZ;
        layer = this.layerADIZ;
        layerConfig = configTrainingAirspaceLayer;
        tooltip = this._tooltipADIZ.bind(this);
        break;
      default:
    }
    return {
      dh: dh,
      layer: layer,
      layerConfig: layerConfig,
      tooltip: tooltip,
    }
  }

  _allLayers() {
    return [
      this.layerJSDFHigh,
      this.layerJSDFLow,
      this.layerCivil,
      this.layerADIZ,
    ];
  }

  _tooltip(geo) {
    const prop = geo.properties;
    const tooltip = [`<ul>`];
    tooltip.push(`<li>name: ${prop.area}</li>`);
    tooltip.push(`<li>flightlevel: ${prop.flightlevel}</li>`);
    tooltip.push(`</ul>`);
    return tooltip.join('');
  }

  _tooltipADIZ(geo) {
    const prop = geo.properties;
    const tooltip = [`<ul>`];
    tooltip.push(`<li>name: ${prop.area}</li>`);
    tooltip.push(`</ul>`);
    return tooltip.join('');
  }

  setContentsDispatcher(dispatcher) {
    this.contentsDispatcher = dispatcher;
  }
}

export default TrainingAirspace;
